import { Box, Card, H3, Icon, IconName, Text } from '@betterment/samba-react';

type ReturnDescriptionCardProps = {
  description: string;
  iconName: string;
  header: string;
};

export const ReturnDescriptionCard: React.FC<ReturnDescriptionCardProps> = ({ description, iconName, header }) => {
  return (
    <Card
      css={{
        padding: 'space.300',
        borderWidth: 'thin',
        borderStyle: 'solid',
        borderColor: 'border.weak',
        boxShadow: 'none',
        borderRadius: 'large',
      }}
    >
      <Card.Content css={{ display: 'flex', gap: 'space.200' }}>
        <Box>
          <Icon name={iconName as IconName} size="small" />
        </Box>
        <Box css={{ display: 'grid', gap: 'space.100', flex: 1 }}>
          <H3 variant="title200">{header}</H3>
          <Text as="p">{description}</Text>
        </Box>
      </Card.Content>
    </Card>
  );
};
